export const prod = true;
export const hostPublicPath =
  "https://s3.eu-central-1.amazonaws.com/marevo.vision/RelevantProjects/webAR/Marevo-OM/kc_prod/dist"; //public
